<div
  class="cheat-sheet-grid"
  [class.is-paint-mode]="paintMode()"
  [class.is-paint-ready]="paintCursor() != null"
  [style.--hd-paint-cursor]="paintCursor()"
>
  @for (gate of gates(); track trackGate($index, gate)) {
    <hd-card-feedback class="cheat-sheet-grid-card" [feedback]="feedbackFor(gate)" [attr.data-gate]="gate">
      <hd-gate-info-cheat-sheet
        [context]="contextFor(gate)"
        [hideGateNumber]="hideGateNumber()"
        [hideKeynotes]="hideKeynotes()"
        [hideColors]="hideColors()"
        [hideFooterCircuit]="hideFooterCircuit()"
        [hideFooterChannel]="hideFooterChannel()"
        [hideBody]="hideBody()"
        [bodyView]="bodyView()"
        [colorConfig]="colorConfig()"
        [revealOverride]="isRevealed(gate)"
        (cardClicked)="onCardClicked($event)"
      ></hd-gate-info-cheat-sheet>
    </hd-card-feedback>
  }
</div>
